import { useState } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { Building2, ChevronUp, LogOut, UserRound } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { baseURL } from '../../AxiosConfig';
import { useAuthContext } from '../../contexts/AuthContext';
import { initials } from '../../modules/agenda/booking/BookingParts';

// Cartao da conta no menu movel: a linha inteira e tocavel e abre as acoes da conta.
export function MenuAccountCard({ onNavigate }: { onNavigate: () => void }) {
    const navigate = useNavigate();
    const { logout, user } = useAuthContext();
    const [photoFailed, setPhotoFailed] = useState(false);
    const name = user?.displayName || user?.email || 'Conta';
    const detail = user?.displayName ? user?.email || user?.phoneNumber : user?.phoneNumber;
    const itemClass = 'flex min-h-11 w-full items-center gap-3 rounded-xl px-3 text-left text-sm font-medium text-base-content data-[focus]:bg-base-content/[0.07]';

    const goTo = (path: string) => {
        navigate(path);
        onNavigate();
    };

    return (
        <Menu>
            <MenuButton className="flex w-full items-center gap-3 rounded-2xl bg-base-content/[0.06] p-2 pr-3 text-left transition-colors hover:bg-base-content/[0.09] data-[active]:bg-base-content/[0.09]">
                <span className="relative flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-base-content/10 text-sm font-semibold text-base-content/60">
                    {initials(name)}
                    {!photoFailed && (
                        <img src={`${baseURL}/users/profileImage/${user?.uid}`} alt="" className="absolute inset-0 h-full w-full object-cover" onError={() => setPhotoFailed(true)} />
                    )}
                </span>
                <span className="min-w-0 flex-1">
                    <span className="block truncate text-sm font-semibold leading-tight text-base-content">{name}</span>
                    {!!detail && <span className="mt-0.5 block truncate text-xs leading-tight text-base-content/55">{detail}</span>}
                </span>
                <ChevronUp size={14} strokeWidth={2} className="shrink-0 text-base-content/40" aria-hidden="true" />
            </MenuButton>

            <MenuItems
                anchor={{ to: 'top start', gap: 8 }}
                transition
                className="sf-menu-account-popover z-[9999] w-[var(--button-width)] p-1.5 outline-none transition data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75"
            >
                <MenuItem>
                    <button type="button" className={itemClass} onClick={() => goTo('/configuracoes/usuario')}>
                        <UserRound size={16} strokeWidth={1.75} className="shrink-0 text-base-content/50" aria-hidden="true" />
                        Minha conta
                    </button>
                </MenuItem>
                {(user?.root || user?.admin) && (
                    <MenuItem>
                        <button type="button" className={itemClass} onClick={() => goTo('/configuracoes/estabelecimento')}>
                            <Building2 size={16} strokeWidth={1.75} className="shrink-0 text-base-content/50" aria-hidden="true" />
                            Estabelecimento
                        </button>
                    </MenuItem>
                )}
                <div className="mx-3 my-1 h-px bg-base-content/10" aria-hidden="true"></div>
                <MenuItem>
                    <button type="button" className={`${itemClass} !text-error`} onClick={() => logout()}>
                        <LogOut size={16} strokeWidth={1.75} className="shrink-0" aria-hidden="true" />
                        Sair
                    </button>
                </MenuItem>
            </MenuItems>
        </Menu>
    );
}
